import { ReactNode } from 'react';

interface IHeader {
	children: ReactNode;
}

import './style.less';

export default function Header({
	children = null,
} : IHeader) {
	return <div className="header">
		{children}
	</div>;
}
